import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AnalyticsTimelineResult } from 'src/app/models/ianalytics.interface';
import { ChartOptionsTimeline } from 'src/app/models/igraph.model';

@Component({
  selector: 'app-timeline-graph-line',
  templateUrl: './timeline-graph-line.component.html',
  styleUrls: ['./timeline-graph-line.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineGraphLineComponent implements OnInit, OnChanges {

  @Input() data: AnalyticsTimelineResult[];
  @Output() refreshed = new EventEmitter<string>();

  modes = [
    { name: 'По часам', code: "HOURS"},
    { name: 'По дням', code: "DAYS"},
    { name: 'По 7 дней', code: "WEEKS"},
    { name: 'По 30 дней', code: "MONTHS"}
  ];

  caption: string = '';

  mode: string = 'DAYS';

  graphOptions: Partial<ChartOptionsTimeline>;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges()  {
    if (this.data.length > 0) {
      const caption : string = this.data.map(o => o.caption).join(' / ');
      this.caption = caption;
      const measure = this.data[0].measure;
      const series = [];
      this.data.forEach(item => {
        const dates = [];
        item.data.forEach(a => dates.push([new Date(a.date).getTime(), a.value]))
        series.push({ name: item.caption , data: dates.sort((a,b) => (a[0] > b[0]) ? 1 : ((b[0] > a[0]) ? -1 : 0)) })
      });
      this.graphOptions = {
        series: series,
        chart: {
          type: "area",
          stacked: false,
          height: 480,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "zoom"
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: caption,
          align: "left"
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100]
          }
        },
        yaxis: {
          labels: {
            formatter: function(val) {
              return (val).toFixed(0);
            }
          },
          title: {
            text: measure
          }
        },
        xaxis: {
          type: "datetime"
        },
        tooltip: {
          shared: false,
          y: {
            formatter: function(val) {
              return val + ' человек';
            }
          }
        }
      };
    }
  }

  onRefresh() {
    this.refreshed.emit(this.mode);
  }

  onModeChanged(e: any) {
    this.refreshed.emit(this.mode);
  }

}
